import Slider from "@mui/material/Slider";
import { FILTER_KEYS } from "@asez/shared";
import { FiltersType } from "../../types";

const getLabels = (selected: number[] = []) => {
  const labels = [
    { value: 0, label: "0%" },
    { value: 100, label: "100%" },
  ];

  selected.forEach((value) => {
    labels.push({
      value,
      label: `${value}%`,
    });
  });

  return labels;
};

export const RangeSlider = ({
  filters,
  filterKey,
  updateFilters,
}: {
  filters: FiltersType;
  filterKey: FILTER_KEYS;
  updateFilters: (key: FILTER_KEYS, value: number[]) => void;
}) => {
  return (
    <Slider
      value={filters[filterKey] as number[]}
      marks={getLabels(filters[filterKey] as number[])}
      min={0}
      max={100}
      onChange={(e, newValue) => updateFilters(filterKey, newValue as number[])}
      sx={{ color: "var(--color-neutral-dark)" }}
    />
  );
};
